"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUEST_FLIGHT_CHANGE = void 0;
exports.REQUEST_FLIGHT_CHANGE = {
    USER_NOT_FOUND: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'USER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Usuário não encontrado.',
        },
    },
    TRAVEL_NOT_FOUND: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'TRAVEL_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Viagem não encontrada.',
        },
    },
    OFFER_NOT_FOUND: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'OFFER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A oferta original não encontrada.',
        },
    },
    USER_NOT_BELONG_TO_FLIGHT_CHANGE: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'USER_NOT_BELONG_TO_SESSION',
        messageLangMap: {
            'PT-BR': 'O usuário logado não é válido.',
        },
    },
    FLIGHT_CHANGE_INCOMPLETE_DATA: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'FLIGHT_CHANGE_INCOMPLETE_DATA',
        messageLangMap: {
            'PT-BR': 'As informações dos passos anteriores não foram preenchidas ou salvas.',
        },
    },
    SUPPLIER_CONFIG_NOT_FOUND: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'SUPPLIER_CONFIG_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Configuração do fornecedor não encontrada.',
        },
    },
    EXIST_OPEN_REQUESTS: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'EXIST_OPEN_REQUESTS',
        messageLangMap: {
            'PT-BR': 'Há uma solicitação pendente para esta oferta.',
        },
    },
    FLIGHT_CHANGE_NOT_FOUND: {
        usecase: 'RECALCULATE_FLIGHT_CHANGES',
        type: 'FLIGHT_CHANGE_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'A alteração de voo não foi encontrada.',
        },
    },
    INVALID_PAYMENT_TYPE: {
        usecase: 'REQUEST_FLIGHT_CHANGE',
        type: 'INVALID_PAYMENT_TYPE',
        messageLangMap: {
            'PT-BR': 'O tipo de pagamento não é válido.',
        },
    },
};
